import { createApiSlice } from "@common";
import {
  CRUD_SERVICES
} from "@routes";

const apiConfig = [
  {
    name: "addServices",
    method: "post",
    url: CRUD_SERVICES,
    stateKey: "message",
  },

  {
    name: "getServices",
    method: "get",
    url: CRUD_SERVICES,
    stateKey: "data",
  },

  {
    name: "updateServices",
    method: "put",
    url: CRUD_SERVICES,
    stateKey: "message",
  },

  {
    name: "deleteServices",
    method: "delete",
    url: CRUD_SERVICES,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "services",
  apiConfig,
  customReducers);
const servicesSlice = slice;

export default servicesSlice.reducer;

export const {
  addServices,
  getServices,
  updateServices,
  deleteServices,
} = thunks;

export const { rowSelect } = actions;
